import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'any',
})

export class MonitoringDataService {

  token = '';
  private apiUrlMonitoringData = `${environment.dwApiUrl}/monitoring/GetMonitoringDataByAccountNumber/`;
  private apiUrlAccountNumberByEmail = `${environment.zuoraApiUrl}/account/contactemailverify/`;
  private apiUrlAccountNumberByPhoneNumber = `${environment.zuoraApiUrl}/account/contact/`;

  constructor(private http: HttpClient, private auth: AuthService) { }

  public fetchAccountNumber(): Observable<string[]> {
    return this.auth.user$.pipe(
      switchMap((userProfile) => {
        let url: string;
        url = '';

        if (userProfile?.email) {
          url = `${this.apiUrlAccountNumberByEmail}${userProfile.email}`;
        } else if (userProfile?.phone_number) {
          url = `${this.apiUrlAccountNumberByPhoneNumber}${userProfile.phone_number}`;
        } else {
          alert('No email or phone number found in user profile.');
        }

        return this.auth.getAccessTokenSilently().pipe(
          tap((token) => (this.token = token)),
          switchMap((token) => {
            const headers = new HttpHeaders({
              Authorization: `Bearer ${this.token}`,
            });

            return this.http.get<any>(url, { headers }).pipe(
              map((response) => {
                const accountNumbers: string[] = [];
                for (let i = 0; i < response.data.length; i++) {
                  const accountNumber = response.data[i].account_number;
                  accountNumbers.push(accountNumber);
                }
                return accountNumbers;
              }
              ),
              catchError(this.handleError)
            );
          }),
          tap(() => console.log('Account Number fetched successfully'))
        );
      })
    );
  }

  getMonitoringData(accountNumber: string): Observable<any> {
    let apiToken: string | null = null;

    return this.auth.getAccessTokenSilently().pipe(
      tap((token) => (this.token = token)),
      switchMap((response) => {
        const url = this.apiUrlMonitoringData + accountNumber;
        const headers = new HttpHeaders({
          Authorization: `Bearer ${this.token}`,
        });

        return this.http
          .get(url, { headers })
          .pipe(catchError(this.handleError));
      }),
      tap(() => console.log('Monitoring data fetched successfully'))
    );
  }

  downloadCSV(data: any[]): void {
    const csvData = this.convertToCSV(data);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = 'monitoring_data.csv';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  private convertToCSV(data: any[]): string {
    const header = Object.keys(data[0]).join(',');
    const rows = data.map((row) => Object.values(row).join(','));
    return [header, ...rows].join('\n');
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An unknown error occurred!';
    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      // Backend error
      errorMessage = `Server-side error: ${error.status} ${error.message}`;
    }
    return throwError(errorMessage);
  }

}
